module.exports = __webpack_public_path__ + "img/recycling-recycle.82ab2682.svg";